import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RtdbService {

  private RTDB_KEY_REPLACEMENTS: Record<string, string> = {
    '.': '§',
    '$': '¤',
    '#': 'µ',
    '[': '«',
    ']': '»',
    '/': '¶',
  };
  private REVERSE_REPLACEMENTS: Record<string, string> = Object.fromEntries(
    Object.entries(this.RTDB_KEY_REPLACEMENTS).map(([k, v]) => [v, k])
  );

  constructor() {
  }

  encodeRtdbKey(key: string): string {
    return key.split('').map(char => this.RTDB_KEY_REPLACEMENTS[char] || char).join('');
  }

  decodeRtdbKey(encodedKey: string): string {
    return encodedKey.split('').map(char => this.REVERSE_REPLACEMENTS[char] || char).join('');
  }

  sanitizeForRtdbJson(value: any): any {
    if (Array.isArray(value)) {
      return value.map(item => this.sanitizeForRtdbJson(item));
    }

    if (value instanceof Date) {
      return value.toISOString();
    }

    if (value && typeof value === 'object') {
      const sanitizedObj: Record<string, any> = {};
      for (const key of Object.keys(value)) {
        const safeKey = this.encodeRtdbKey(key);
        sanitizedObj[safeKey] = this.sanitizeForRtdbJson(value[key]);
      }
      return sanitizedObj;
    }

    return value;
  }

}
